import { render, staticRenderFns } from "./BoardPage.vue?vue&type=template&id=9a1df034&scoped=true&"
import script from "./BoardPage.vue?vue&type=script&lang=js&"
export * from "./BoardPage.vue?vue&type=script&lang=js&"
import style0 from "./BoardPage.vue?vue&type=style&index=0&id=9a1df034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1df034",
  null
  
)

export default component.exports